<template>
  <div class="header">
    <HeaderButton @clickFunction="onBtnHeaderClick()"></HeaderButton>

    <div
      class="header__items"
      v-if="$tvaMq !== 'mobile' && $tvaMq !== 'tablet'"
    >
      <!-- [TODO] MENù BOX -->
      <div
        v-for="(c, index) in headerItems.filter((o) => !o.hidden)"
        :key="index"
      >
        <transition-group :name="'fade'">
          <MenuItem
            :key="index"
            v-if="showHamburgerButton()"
            :item="c"
            @MenuItemClick="onMenuItemClick"
          ></MenuItem>
        </transition-group>
      </div>
      <div class="header__items__logo-wrapper">
        <a
          class="header__items__logo"
          href="https://www.eni.com/en-IT/home.html"
          target="blank"
        >
          <img
            :src="`${$baseUrl}images/Logo_eni.svg`"
            alt="Eni logo"
            class="logo"
          />
        </a>
      </div>
    </div>
    <div v-else class="header__items">
      <div class="header__items__logo-wrapper">
        <a
          class="header__items__logo"
          href="https://www.eni.com/en-IT/home.html"
          target="blank"
        >
          <img
            :src="`${$baseUrl}images/Logo_eni.svg`"
            alt="Eni logo"
            class="logo"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import MenuItem from "@/components/MenuItem.vue";
import menuHelper from "@/mixins/menuHelper";
import HeaderButton from "@/components/HeaderButton.vue";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "Header",
  mixins: [menuHelper],
  components: {
    MenuItem,
    HeaderButton,
  },
  beforeRouteEnter() {},
  computed: {
    content() {
      return this.$t("headerAndMenu");
    },
    headerItems() {
      return this.content.items.filter((x) => x.header === true);
    },

    ...mapGetters({
      previousLink: "ui/previousLink",
      landingIndex: "scroller/landingIndex",
      isMenuOpen: "ui/isMenuOpen",
      isModalOpen: "ui/isModalOpen",
      modalContent: "ui/modalContent",
    }),
  },
  methods: {
    showHamburgerButton() {
      return !this.isMenuOpen && !this.isModalOpen;
    },
    showCloseButton() {
      return this.isMenuOpen || this.isModalOpen;
    },
    onMenuItemClick(item) {
      item.internalPdf
        ? this.onExternalMenuClick(item)
        : this.onModalMenuClick(item);
    },
    onBtnHeaderClick() {
      if (this.showCloseButton()) {
        //current btn is X --> close modal or menu
        this.setDirection("rtl");
        if (this.isModalOpen) {
          this.toggleModal(false);
        } else if (this.isMenuOpen) {
          this.previousLink && this.previousLink.path !== "/" &&
            this.$router.push(this.previousLink);
          this.toggleMenu(false);
        }

        if (this.mainSource) {
          // if source was selected go back to source page on close
          if (this.$route.path !== "/" + this.mainSource)
            this.$router.push("/" + this.mainSource);
        }
      } else if (this.showHamburgerButton()) {
        this.setDirection("ltr");
        //current btn is hamburger --> OPEN MENU
        this.toggleMenu(true);
      }
    },
    ...mapActions({
      setDirection: "scroller/setDirection",
    }),
  },
};
</script>

<style lang="scss">
.header {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;

  &__items {
    padding-left: calc(
      toRem($landing-side-WIDTH) + ($background-lines-WIDTH * 4)
    );
    padding-right: $landing-margin-right-left;
    height: 100%;
    width: 100%;
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: space-between;

    &__logo {
      &-wrapper {
        width: $background-lines-WIDTH;
        display: flex;
        justify-content: flex-end;
        justify-self: flex-end;
      }
      justify-self: flex-end;
      pointer-events: all;
      background-color: $ui-white;
      box-shadow: 0px 0px 38.0278px 4.75347px rgba(0, 0, 0, 0.1);
      padding: toRem(7) toRem(17);
      border-radius: toRem(200);
      display: flex;
      align-items: center;
      height: 42px;
      display: inline-block;
      img {
        width: 90px;
        height: auto;
      }
    }
  }
}

.mobile {
  .header {
    height: 8.2vh;
    &__items {
      padding: 0;
      padding-right: 4.5vw;
      &__logo {
        display: flex;
        justify-content: center;
        width: 28vw;
        height: 5vh;
        align-items: center;
        &-wrapper {
          width: 100%;
          img {
            width: toRem(78);
          }
        }
      }
    }
  }
}

.tablet {
  .header {
    height: fit-content;
    &__items {
      padding-left: 0;
      padding-right: 0;
      &__logo {
        width: 13.7vw;
        margin-right: 5vw;
        margin-top: 1.83vh;
        display: flex;
        justify-content: center;
        &-wrapper {
          width: 100%;
        }
        img {
          width: 10.15vw;
        }
      }
    }
  }
}
</style>
